var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { attrs: { fluid: "lg" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    [
                      _c("div", { staticClass: "text-center mb-3" }, [
                        _c("img", {
                          staticClass: "mb-3 logo",
                          attrs: { src: "/imgs/logoAbelha.png", alt: "" }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-skeleton-wrapper",
                        {
                          attrs: { loading: _vm.firstLoading },
                          scopedSlots: _vm._u([
                            {
                              key: "loading",
                              fn: function() {
                                return [
                                  _c(
                                    "b-card",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "100%" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c("b-skeleton", {
                                            attrs: {
                                              height: "40%",
                                              width: "100%"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton-img", {
                                                attrs: { width: "50%" }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton-img", {
                                                attrs: { width: "50%" }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "100%" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("div", { staticClass: "text-center mt-3" }, [
                            _c("h2", { staticClass: "mt-3 distribuidor" }, [
                              _vm._v("Olá " + _vm._s(_vm.distribuidor.nome))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "mt-3 mb-3 title" }, [
                            _vm._v(
                              "Com o intuito de manter atualizado o cadastro dos nossos clientes, necessitamos\n              que preencha\n              alguns dados neste formulário!"
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-row", { staticClass: "mt-3 mb-3" }, [
                            _c("h5", [
                              _vm._v(
                                "Código do Distribuidor: " +
                                  _vm._s(_vm.distribuidor.codigo)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "nome" } }, [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(" Nome do Responsável:")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { id: "nome", placeholder: "Nome" },
                                    model: {
                                      value: _vm.responsavel,
                                      callback: function($$v) {
                                        _vm.responsavel = $$v
                                      },
                                      expression: "responsavel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "nome" } }, [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(" CPF do Responsável:")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["###.###.###-##"],
                                        expression: "['###.###.###-##']"
                                      }
                                    ],
                                    attrs: {
                                      state: _vm.cpfState,
                                      id: "nome",
                                      placeholder: "CPF"
                                    },
                                    model: {
                                      value: _vm.cpf,
                                      callback: function($$v) {
                                        _vm.cpf = $$v
                                      },
                                      expression: "cpf"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "email" } }, [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(" E-mail:")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      state: _vm.emailState,
                                      id: "email",
                                      placeholder: "E-mail"
                                    },
                                    model: {
                                      value: _vm.email,
                                      callback: function($$v) {
                                        _vm.email = $$v
                                      },
                                      expression: "email"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "data" } }, [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(
                                      " Data de Nascimento do Responsável:"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: { type: "date", id: "data" },
                                    model: {
                                      value: _vm.nascimento,
                                      callback: function($$v) {
                                        _vm.nascimento = $$v
                                      },
                                      expression: "nascimento"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-card",
                                    [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(
                                        " Telefone Principal:\n                  "
                                      ),
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: [
                                              "(##) ####-####",
                                              "(##) #####-####"
                                            ],
                                            expression:
                                              "['(##) ####-####', '(##) #####-####']"
                                          }
                                        ],
                                        staticClass: "mt-3",
                                        attrs: {
                                          id: "telefone1",
                                          placeholder: "Numero"
                                        },
                                        model: {
                                          value: _vm.telPrincipal,
                                          callback: function($$v) {
                                            _vm.telPrincipal = $$v
                                          },
                                          expression: "telPrincipal"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { for: "wppP" }
                                        },
                                        [_vm._v("Whatsapp")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-checkbox", {
                                        attrs: {
                                          id: "wppP",
                                          name: "check-button",
                                          switch: ""
                                        },
                                        model: {
                                          value: _vm.wppPrincipal,
                                          callback: function($$v) {
                                            _vm.wppPrincipal = $$v
                                          },
                                          expression: "wppPrincipal"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-card",
                                    [
                                      _c("span", [_vm._v("*")]),
                                      _vm._v(
                                        " Telefone para Recado:\n                  "
                                      ),
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: [
                                              "(##) ####-####",
                                              "(##) #####-####"
                                            ],
                                            expression:
                                              "['(##) ####-####', '(##) #####-####']"
                                          }
                                        ],
                                        staticClass: "mt-3",
                                        attrs: {
                                          id: "telefone1",
                                          placeholder: "Numero"
                                        },
                                        model: {
                                          value: _vm.telRecado,
                                          callback: function($$v) {
                                            _vm.telRecado = $$v
                                          },
                                          expression: "telRecado"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { for: "wppR" }
                                        },
                                        [_vm._v("Whatsapp")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-checkbox", {
                                        attrs: {
                                          id: "wppR",
                                          name: "check-button",
                                          switch: ""
                                        },
                                        model: {
                                          value: _vm.wppRecado,
                                          callback: function($$v) {
                                            _vm.wppRecado = $$v
                                          },
                                          expression: "wppRecado"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    variant: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.salvar()
                                    }
                                  }
                                },
                                [
                                  _vm.loading
                                    ? _c("b-spinner", {
                                        attrs: {
                                          small: "",
                                          label: "Loading..."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "fas fa-save" }),
                                  _vm._v(
                                    "\n                Salvar\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d701238", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d701238","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/atualizacao.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d701238","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/atualizacao.vue
// module chunks = 2